import { type Locale } from 'date-fns';
import { enUS, es } from 'date-fns/locale';

export const supportedLocales = new Map<
  string,
  { locale: Locale; display: string }
>([
  [
    'en',
    {
      locale: enUS,
      display: 'English',
    },
  ],
  [
    'es',
    {
      locale: es,
      display: 'Español',
    },
  ],
]);
